import { render, staticRenderFns } from "./BlockScreenModal.vue?vue&type=template&id=65ad2d58"
import script from "./BlockScreenModal.vue?vue&type=script&lang=js"
export * from "./BlockScreenModal.vue?vue&type=script&lang=js"
import style0 from "./BlockScreenModal.vue?vue&type=style&index=0&id=65ad2d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports